<template>
    <main-layout id="list-outils">

        <app-header icon="tool">
            Outillages
        </app-header>

        <action-bar :back="{name: 'home'}">
            <router-link class="btn add btn-full" id="main-action" to="new-outil">
                <i class="icon-add"></i>
                <strong>Ajouter</strong> un outillage
            </router-link>
        </action-bar>

        <filter-bar @searchBarChanged="updateSearch"
                    :gotFilter="true"
                    filterText="Outillage actif"
                    @filterValChanged="changeList"
                    placeholderFilter="Rechercher Nom, Marque, Modèle">
        </filter-bar>

        <div id="outils-items" class="list outils" v-show="listVisible === 'active'">
            <outil-item v-for="outil in filterList" :key="outil.id" :outil="outil" @listUpdated="handleNewList"></outil-item>
        </div>

        <div id="outils-items-inact" class="list outils" v-show="listVisible === 'inactive'">
            <outil-item v-for="outil in filterListInact" :key="outil.id" :outil="outil" @listUpdated="handleNewList"></outil-item>
        </div>

    </main-layout>
</template>

<script>

    import OutilItem from './OutilItem.vue'
    import Outil from '../../js/models/Outil'

    export default {

        data() {
            return {
                outils: [],
                strSearch: '',
                listVisible: 'active'
            }
        },

        computed: {

            filterList() {
                return this.outils.filter(outil => {
                    let check = false;
                    if (_.has(outil, 'type_outil') && outil.type_outil.nom.toLowerCase().includes(this.strSearch)) {
                        check = true
                    }
                    if (outil.marque.toLowerCase().includes(this.strSearch)) {
                        check = true
                    }
                    if (outil.modele.toLowerCase().includes(this.strSearch)) {
                        check = true
                    }
                    if(outil.actif === false){
                        check = false
                    }
                    if (check) {
                        return outil
                    }
                })
            },

            filterListInact(){
                return this.outils.filter(outil => {
                    let check = false;
                    if (_.has(outil, 'type_outil') && outil.type_outil.nom.toLowerCase().includes(this.strSearch)) {
                        check = true
                    }
                    if (outil.marque.toLowerCase().includes(this.strSearch)) {
                        check = true
                    }
                    if (outil.modele.toLowerCase().includes(this.strSearch)) {
                        check = true
                    }
                    if(outil.actif === true){
                        check = false
                    }
                    if (check) {
                        return outil
                    }
                })
            }

        },

        methods: {

            handleNewList() {
                this.fetchOutils()
            },

            fetchOutils() {
                let vueInstance = this;
                Outil.getList().then(res => vueInstance.outils = res)
            },

            updateSearch(str) {
                this.strSearch = String(str[0]).toLowerCase()
            },

            changeList(filter){
                if(filter === false){
                    this.listVisible = 'inactive'
                } else {
                    this.listVisible = 'active'
                }
            }

        },

        mounted() {

            this.fetchOutils();

            Outil
                .getDetecteurActif()
                .then(() => {
                })
                .catch(() => {
                })

        },

        components: {
            OutilItem
        }

    }

</script>



// WEBPACK FOOTER //
// ListeOutils.vue?214839b0